(function () {
  var MINIMUM_CENTS = 14995;
  var timer = null;
  var checking = false;
  var lastValid = true;
  var lastCart = null;

  function money(cents) {
    return new Intl.NumberFormat('en-US', { style:'currency', currency:'USD' }).format(cents / 100);
  }

  function isMinimumEligibleItem(item) {
    // Italian Ruscus has independently priced packages, including a single five-bunch package.
    var productId = String(item && item.product_id || '').split('/').pop();
    var packageHandle = String(item && (item.handle || item.product_handle) || '').toLowerCase();
    if (productId === '15405744521367' || packageHandle === 'fresh-italian-ruscus') return false;
    if (item && item.properties && String(item.properties._bf_custom_garland) === 'true') return true;
    var handle = String(item && (item.handle || item.product_handle) || '').toLowerCase();
    var title = String(item && (item.product_title || item.title) || '').toLowerCase();
    var vendor = String(item && item.vendor || '').toLowerCase();
    var type = String(item && item.product_type || '').toLowerCase();
    if (/fee/.test(handle) || /fee/.test(title)) return false;
    return /^fresh[-_]/.test(handle) || /^fresh\b/.test(title) || /fresh/.test(vendor) || /fresh/.test(type) || /garland/.test(handle) || /garland/.test(title);
  }

  function render(cart) {
    lastCart = cart;
    var eligibleItems = (cart.items || []).filter(isMinimumEligibleItem);
    var subtotal = eligibleItems.reduce(function (sum, item) {
      var linePrice = item.final_line_price == null ? item.original_line_price : item.final_line_price;
      return sum + Number(linePrice || 0);
    }, 0);
    lastValid = !eligibleItems.length || subtotal >= MINIMUM_CENTS;

    document.querySelectorAll('[data-bf-garland-minimum-cart]').forEach(function (notice) { notice.remove(); });
    document.querySelectorAll('button[name="checkout"], input[name="checkout"]').forEach(function (button, index) {
      var noticeId = 'BfGarlandCartMinimum-' + index;
      if (!button.hasAttribute('data-bf-garland-original-disabled')) button.setAttribute('data-bf-garland-original-disabled', button.disabled ? 'true' : 'false');
      if (lastValid) {
        if (button.getAttribute('data-bf-garland-original-disabled') !== 'true') button.disabled = false;
        button.removeAttribute('aria-describedby');
        button.style.removeProperty('cursor');
        button.style.removeProperty('filter');
        button.style.removeProperty('opacity');
        return;
      }
      button.disabled = true;
      button.setAttribute('aria-describedby', noticeId);
      button.style.setProperty('cursor', 'not-allowed', 'important');
      button.style.setProperty('filter', 'saturate(.35)', 'important');
      button.style.setProperty('opacity', '.42', 'important');
      var wrapper = button.closest('.cart__checkout-wrapper') || button.parentElement;
      if (wrapper) {
        var notice = document.createElement('p');
        notice.id = noticeId;
        notice.className = 'bf-garland-cart-minimum';
        notice.setAttribute('data-bf-garland-minimum-cart', '');
        notice.textContent = 'Fresh products and garlands require a $149.95 minimum. Add ' + money(MINIMUM_CENTS - subtotal) + ' more in Fresh products or garlands before checkout.';
        wrapper.insertBefore(notice, button);
      }
    });
  }

  function check() {
    if (checking) return;
    checking = true;
    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js', { credentials:'same-origin', cache:'no-store' })
      .then(function (response) { if (!response.ok) throw new Error('cart'); return response.json(); })
      .then(render)
      .catch(function () { lastValid = true; })
      .finally(function () { checking = false; });
  }

  function schedule() {
    if (timer) window.clearTimeout(timer);
    timer = window.setTimeout(function () { timer = null; check(); }, 120);
  }

  document.addEventListener('DOMContentLoaded', schedule);
  ['ajaxProduct:added', 'cart:rebuilt', 'cart:quantity', 'cart:build', 'cart:updated'].forEach(function (name) { document.addEventListener(name, schedule); });
  document.addEventListener('submit', function (event) {
    if (!event.target.closest('form[action*="/cart"]') || !event.submitter || event.submitter.name !== 'checkout') return;
    if (!lastValid) {
      event.preventDefault();
      window.alert('Fresh products and garlands require a $149.95 minimum.');
    }
  }, true);

  document.addEventListener('click', function (event) {
    var checkout = event.target.closest && event.target.closest('[name="checkout"]');
    if (!checkout || lastValid) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    window.alert('Fresh products and garlands require a $149.95 minimum.');
  }, true);

  new MutationObserver(function (mutations) {
    var checkoutAdded = mutations.some(function (mutation) {
      return Array.prototype.some.call(mutation.addedNodes || [], function (node) {
        return node.nodeType === 1 && ((node.matches && node.matches('[name="checkout"]')) || (node.querySelector && node.querySelector('[name="checkout"]')));
      });
    });
    if (checkoutAdded && lastCart) window.setTimeout(function () { render(lastCart); }, 0);
  }).observe(document.documentElement, { childList:true, subtree:true });
}());